import { render, staticRenderFns } from "./CRUDTableRelationship.vue?vue&type=template&id=db141e36"
import script from "./CRUDTableRelationship.vue?vue&type=script&lang=js"
export * from "./CRUDTableRelationship.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableRelationship.vue?vue&type=style&index=0&id=db141e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports